// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__10lq0","footer":"Form_footer__1JfgM"};